<template>
  <div class="key-viewInformation">
    <el-tabs type="border-card" tab-position="left" style="height: auto;">
      <el-tab-pane v-if="hasContent(srcList1Image, srcList1PDF, srcList1Video)"
        label="身份证正面">
        <!-- <div class="image-list">
          <el-image class="elimages" v-for="(item, i) in srcList1" :key="i" :src="item" :preview-src-list="srcList1">
          </el-image>
        </div> -->
        <div class="image-list">
          <div v-if="srcList1Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList1Image" :key="i" :src="item"
              :preview-src-list="srcList1Image">
            </el-image>
          </div>
          <div v-if="srcList1PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList1PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList1PDF)" />
          </div>
          <div v-if="srcList1Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList1Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList2Image, srcList2PDF, srcList2Video)"
        label="身份证反面">
        <div class="image-list">
          <div v-if="srcList2Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList2Image" :key="i" :src="item"
              :preview-src-list="srcList2Image">
            </el-image>
          </div>
          <div v-if="srcList2PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList2PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList2PDF)" />
          </div>
          <div v-if="srcList2Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList2Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList3Image, srcList3PDF, srcList3Video)"
        label="logo合影照">
        <div class="image-list">
          <div v-if="srcList3Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList3Image" :key="i" :src="item"
              :preview-src-list="srcList3Image">
            </el-image>
          </div>
          <div v-if="srcList3PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList3PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList3PDF)" />
          </div>
          <div v-if="srcList3Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList3Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList4Image, srcList4PDF, srcList4Video)"
        label="商户协议">
        <div class="image-list">
          <div v-if="srcList4Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList4Image" :key="i" :src="item"
              :preview-src-list="srcList4Image">
            </el-image>
          </div>
          <div v-if="srcList4PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList4PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList4PDF)" />
          </div>
          <div v-if="srcList4Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList4Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList5Image, srcList5PDF, srcList5Video)"
        label="声明凭证">
        <div class="image-list">
          <div v-if="srcList5Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList5Image" :key="i" :src="item"
              :preview-src-list="srcList5Image">
            </el-image>
          </div>
          <div v-if="srcList5PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList5PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList5PDF)" />
          </div>
          <div v-if="srcList5Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList5Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList6Image, srcList6PDF, srcList6Video)"
        label="通讯录详单">
        <div class="image-list">
          <div v-if="srcList6Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList6Image" :key="i" :src="item"
              :preview-src-list="srcList6Image">
            </el-image>
          </div>
          <div v-if="srcList6PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList6PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList6PDF)" />
          </div>
          <div v-if="srcList6Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList6Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList7Image, srcList7PDF, srcList7Video)"
        label="非学生证明">
        <div class="image-list">
          <div v-if="srcList7Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList7Image" :key="i" :src="item"
              :preview-src-list="srcList7Image">
            </el-image>
          </div>
          <div v-if="srcList7PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList7PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList7PDF)" />
          </div>
          <div v-if="srcList7Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList7Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="srcList8.length !== 0" label="活体图片">
        <div class="image-list">
          <el-image class="elimages" v-for="(item, i) in srcList8" :key="i" :src="item" :preview-src-list="srcList8">
          </el-image>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="srcList9.length !== 0" label="活体视频">
        <div class="video-list">
          <video class="video" v-for="(video, index) in srcList9" :key="index" :src="video.src" controls>
          </video>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList10Image, srcList10PDF, srcList10Video)" label="定金凭证">
        <div class="image-list">
          <div v-if="srcList10Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList10Image" :key="i" :src="item"
              :preview-src-list="srcList10Image">
            </el-image>
          </div>
          <div v-if="srcList10PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList10PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList10PDF)" />
          </div>
          <div v-if="srcList10Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList10Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList11Image, srcList11PDF, srcList11Video)"
        label="芝麻分证明">
        <div class="image-list">
          <div v-if="srcList11Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList11Image" :key="i" :src="item"
              :preview-src-list="srcList11Image">
            </el-image>
          </div>
          <div v-if="srcList11PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList11PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList11PDF)" />
          </div>
          <div v-if="srcList11Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList11Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="hasContent(srcList12Image, srcList12PDF, srcList12Video)"
        label="其他证明材料">
        <div class="image-list">
          <div v-if="srcList12Image.length !== 0">
            <el-image class="elimages" v-for="(item, i) in srcList12Image" :key="i" :src="item"
              :preview-src-list="srcList12Image">
            </el-image>
          </div>
          <div v-if="srcList12PDF.length !== 0">
            <img class="elimagePDF" v-for="(item, index) in srcList12PDF" :key="index" src="@/assets/images/pdf.png"
              @click="handleImageClick(index, srcList12PDF)" />
          </div>
          <div v-if="srcList12Video.length !== 0" class="video-list">
            <video class="video" v-for="(video, index) in srcList12Video" :key="index" :src="video" controls>
            </video>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDictionaryList, queryMaterialList, queryFaceList } from '@/api/task'

export default {
  name: 'KeyViewInformation',
  components: {
  },
  data() {
    return {
      srcList1: [],
      srcList1Video: [],
      srcList1PDF: [],
      srcList1Image: [],
      srcList2: [],
      srcList2Video: [],
      srcList2PDF: [],
      srcList2Image: [],
      srcList3: [],
      srcList3Video: [],
      srcList3PDF: [],
      srcList3Image: [],
      srcList4: [],
      srcList4Video: [],
      srcList4PDF: [],
      srcList4Image: [],
      srcList5: [],
      srcList5Video: [],
      srcList5PDF: [],
      srcList5Image: [],
      srcList6: [],
      srcList6Video: [],
      srcList6PDF: [],
      srcList6Image: [],
      srcList7: [],
      srcList7Video: [],
      srcList7PDF: [],
      srcList7Image: [],
      srcList8: [],
      srcList8Video: [],
      srcList8PDF: [],
      srcList8Image: [],
      srcList9: [],
      srcList9Video: [],
      srcList9PDF: [],
      srcList9Image: [],
      srcList10: [],
      srcList10Video: [],
      srcList10PDF: [],
      srcList10Image: [],
      srcList11: [],
      srcList11Video: [],
      srcList11PDF: [],
      srcList11Image: [],
      srcList12: [],
      srcList12Video: [],
      srcList12PDF: [],
      srcList12Image: [],
      userId: null,
      pdfOptions: {
        // 启用放大和缩小功能
        scale: 1.0,
        zoom: {
          value: 1.0,
          min: 0.5,
          max: 2.0,
          step: 0.1
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'taskInfo',
      'currentUser'
    ]),
    id() {
      return this.$route.params.loanId
    },
    taskId() {
      return this.$route.params.taskId
    }
  },
  created() {
    console.log(this.taskId, 'this.taskId')
    const userId = sessionStorage.getItem('userId')
    if (userId) {
      this.userId = userId
      console.log('User ID:', userId)
      // 在这里可以将userId存储在Vue组件的数据中，以便在组件中使用
    } else {
      console.log('User ID not found in cookie.')
    }

    this.getDictionaryListData()
    this.queryMaterialListData()
    this.queryFaceListData()
  },
  methods: {
    hasContent(imageList, pdfList, videoList) {
      return imageList.length !== 0 || pdfList.length !== 0 || videoList.length !== 0
    },
    getDictionaryListData() {
      getDictionaryList('fd_material_type').then((res) => {
        // console.log(res, 'resres')
      })
    },
    addFilesToSrcList(fileList, fileType, srcList) {
      const targetFiles = fileList.filter(item => item.fileType === fileType)
      targetFiles.forEach(targetFile => {
        const ossUrl = targetFile.ossUrl
        srcList.push(ossUrl)
      })
    },
    queryMaterialListData() {
      queryMaterialList({ taskId: this.taskId, userId: this.userId }).then((res) => {
        const fileList = res.data
        this.addFilesToSrcList(fileList, '0', this.srcList1) // 添加身份证正面
        this.addFilesToSrcList(fileList, '1', this.srcList2) // 添加身份证反面
        this.addFilesToSrcList(fileList, '21', this.srcList3) // 添加 logo 合影照

        this.addFilesToSrcList(fileList, '13', this.srcList4) // 添加商户协议
        this.addFilesToSrcList(fileList, '101', this.srcList4) // 添加商户协议
        this.addFilesToSrcList(fileList, '102', this.srcList4) // 添加商户协议
        this.addFilesToSrcList(fileList, '103', this.srcList4) // 添加商户协议
        this.addFilesToSrcList(fileList, '104', this.srcList4) // 添加商户协议

        this.addFilesToSrcList(fileList, '105', this.srcList5) // 添加声明凭证

        this.addFilesToSrcList(fileList, '39', this.srcList6) // 添加通讯录详单
        this.addFilesToSrcList(fileList, '56', this.srcList6) // 添加通讯录详单

        this.addFilesToSrcList(fileList, '137', this.srcList7) // 添加非学生证明

        this.addFilesToSrcList(fileList, '25', this.srcList10) // 添加定金凭证
        this.addFilesToSrcList(fileList, '252', this.srcList10) // 添加定金凭证
        this.addFilesToSrcList(fileList, '100', this.srcList10) // 添加定金凭证

        this.addFilesToSrcList(fileList, '136', this.srcList11) // 添加芝麻分证明
        this.addFilesToSrcList(fileList, '99', this.srcList12) // 添加其他证明材料
        console.log(this.srcList10, 'this.srcList10')

        // 遍历文件列表，根据 type 分类存储到不同的数组中
        fileList.forEach(item => {
          if (item.fileType === '0') {
            if (item.type === 'Video') {
              this.srcList1Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList1PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList1Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '1') {
            if (item.type === 'Video') {
              this.srcList2Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList2PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList2Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '21') {
            if (item.type === 'Video') {
              this.srcList3Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList3PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList3Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '13' || item.fileType === '101' || item.fileType === '102' || item.fileType === '103' || item.fileType === '104') {
            if (item.type === 'Video') {
              this.srcList4Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList4PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList4Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '105') {
            if (item.type === 'Video') {
              this.srcList5Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList5PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList5Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '39' || item.fileType === '56') {
            if (item.type === 'Video') {
              this.srcList6Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList6PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList6Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '137') {
            if (item.type === 'Video') {
              this.srcList7Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList7PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList7Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '25' || item.fileType === '252' || item.fileType === '100') {
            if (item.type === 'Video') {
              this.srcList10Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList10PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList10Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '136') {
            if (item.type === 'Video') {
              this.srcList11Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList11PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList11Image.push(item.ossUrl)
            }
          }
          if (item.fileType === '99') {
            if (item.type === 'Video') {
              this.srcList12Video.push(item.ossUrl)
            } else if (item.type === 'PDF') {
              this.srcList12PDF.push(item.ossUrl)
            } else if (item.type === 'Image') {
              this.srcList12Image.push(item.ossUrl)
            }
          }
        })
        // const fileList = res.data
        // // 身份证正面
        // const targetFile = fileList.find(item => item.fileType === '0')
        // if (targetFile) {
        //   const ossUrl = targetFile.ossUrl
        //   this.srcList1.push(ossUrl)
        // } else {
        // }
        // // 身份证反面
        // const targetFile2 = fileList.find(item => item.fileType === '1')
        // if (targetFile2) {
        //   const ossUrl2 = targetFile2.ossUrl
        //   this.srcList2.push(ossUrl2)
        // } else {
        // }
      })
    },
    handleImageClick(index, srcListPDF) {
      if (index >= 0 && index < srcListPDF.length) {
        const link = srcListPDF[index]
        window.open(link)
      }
    },
    queryFaceListData() {
      queryFaceList({ taskId: this.taskId }).then((res) => {
        if (res.data) {
          if (res.data.pictureBase64) {
            this.srcList8.push(res.data.pictureBase64)
          }
          if (res.data.videoBase64) {
            const videoObj = { src: res.data.videoBase64 }
            this.srcList9.push(videoObj)
          }
        }
      }).catch(error => {
        console.error('Error fetching face list data:', error)
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.image-list {
  display: flex;
  flex-wrap: wrap;

  .elimages {
    width: 180px;
    height: 180px;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
  }

  .elimages:hover {
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, .5);
  }

  .elimagePDF {
    width: 180px;
    height: 180px;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, .3);
  }

  .elimagePDF:hover {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .5);
  }

}

.video-list {
  display: flex;
  flex-wrap: wrap;

  .video {
    width: 300px;
    height: 180px;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
  }

  .video:hover {
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, .5);
  }
}
</style>
